import { render, staticRenderFns } from "./ModelHouseTaskForSample.vue?vue&type=template&id=0576fb95&scoped=true&"
import script from "./ModelHouseTaskForSample.vue?vue&type=script&lang=js&"
export * from "./ModelHouseTaskForSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0576fb95",
  null
  
)

export default component.exports